import CREATE_WAITING_ROOM_FORM from './features/create-waiting-room-form';
import {
    SET_WAITING_ROOMS, EDIT_WAITING_ROOM, DELETE_WAITING_ROOM, SET_WAITING_ROOM_CHART,
    SET_CREATE_WAITING_ROOM_FORM_FIELD, RESET_CREATE_WAITING_ROOM_FORM, SET_WAITING_ROOM_VIEW_INFO,
} from '../actions/waiting-rooms';

const INITIAL_DATA_STATE = {
    waitingRooms: [],
    charts: [],
    waitingRoomViewInfo: {},
    forms: { ...CREATE_WAITING_ROOM_FORM },
};

export const waitingRoomsDataReducer = (state = INITIAL_DATA_STATE, action) => {
    switch (action.type) {
        case SET_WAITING_ROOMS:
            return {
                ...state,
                waitingRooms: action.payload,
            };
        case EDIT_WAITING_ROOM:
            return {
                ...state,
                waitingRooms: constructNewWaitingRoomsArray(state, action.id, action.fieldsNames, action.values),
            };
        case DELETE_WAITING_ROOM:
            return {
                ...state,
                waitingRooms: state.waitingRooms.filter((waitingRoom) => waitingRoom.id !== action.id),
            };
        case SET_WAITING_ROOM_CHART:
            return {
                ...state,
                charts: {
                    ...state.charts,
                    [action.id]: action.chartData,
                },
            };
        case SET_CREATE_WAITING_ROOM_FORM_FIELD:
            return {
                ...state,
                forms: {
                    ...state.forms,
                    createWaitingRoom: {
                        ...state.forms.createWaitingRoom,
                        [action.fieldName]: {
                            value: action.value,
                            isValid: action.isValid,
                        },
                    },
                },
            };
        case SET_WAITING_ROOM_VIEW_INFO:
            return {
                ...state,
                waitingRoomViewInfo: {
                    ...state.waitingRoomViewInfo,
                    [action.payload.id]: action.payload,
                },
            };
        case RESET_CREATE_WAITING_ROOM_FORM:
            return {
                ...state,
                forms: {
                    ...state.forms,
                    createWaitingRoom: INITIAL_DATA_STATE.forms.createWaitingRoom,
                },
            };
        default:
            return state;
    }
};

const constructNewWaitingRoomsArray = (state, id, fieldsNames, values) => {
    const updatedFields = fieldsNames.reduce((acc, fieldName, index) => {
        acc[fieldName] = values[index];
        return acc;
    }, {});

    const updatedWaitingRooms = state.waitingRooms.map((waitingRoom) => {
        if (waitingRoom.id === id) {
            return {
                ...waitingRoom,
                ...updatedFields,
            };
        }
        return waitingRoom;
    });

    const waitingRoomExists = updatedWaitingRooms.some((room) => room.id === id);
    if (!waitingRoomExists) {
        updatedWaitingRooms.push({
            id,
            ...updatedFields,
        });
    }

    return updatedWaitingRooms;
};

export default waitingRoomsDataReducer;
